import merge from 'lodash/merge';
import includes from 'lodash/includes';

import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';
import { AU_LOCALE } from '@eb/intl';
import { gettext } from "@eb/i18n";

import {
    LOCALE_WITH_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_ONE_VERSION_1,
    PACKAGE_TWO,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES,
    PACKAGE_ONE_FEATURES_AU_V2,
    PACKAGE_TWO_FEATURES,
    PACKAGE_TWO_FEATURES_AU,
} from '../../constants/features';
import { canUpdateEssentialsV2 } from '../utils';
import * as features from '../../constants/features';

const OVERRIDE_USER_SETTINGS_VERSION_2 = {
    [PACKAGE_ONE_VERSION_1]: {
        packagesList: {
            CTAs: [
                gettext('Update'),
                gettext('Upgrade'),
                gettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
        grid: {
            CTAs: [
                gettext('Update'),
                gettext('Upgrade'),
                gettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
    },
};

const OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2 = {
    [AU_LOCALE]: {
        packagesList: {
            packages: {
                [PACKAGE_ONE]: {
                    features: [
                        ...features.PACKAGE_ONE_FEATURES_AU_V2,
                        features.TICKET_FEES_PAYMENT_PROCESSING,
                    ],
                },
            },
        },
    },
};

/**
 * Generate additional settings to override the features list and the CTA texts/styles
 * on the essentials package on Australia.
 */
export const generateAdditionalSettings = ({
    locale,
    isAuthenticated,
    assortmentsAvailability = {},
}) => {
    const { current: currentPackage = {} } = assortmentsAvailability || {};
    const { plan, version } = currentPackage;
    let userSettings = {};
    let overrideSettings = {};

    if (!includes(LOCALE_WITH_VERSION_2, locale)) {
        return;
    }

    if (
        isAuthenticated &&
        canUpdateEssentialsV2({ locale, assortmentsAvailability })
    ) {
        userSettings = OVERRIDE_USER_SETTINGS_VERSION_2[PACKAGE_ONE_VERSION_1];
    }

    overrideSettings =
        OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2[locale];

    return merge(overrideSettings, userSettings);
};
